module.exports = __webpack_public_path__ + "static/EGR_FlashPage_2-b3fa673d9b5ef7748b8f40b7065faedc.jpg";